import { keyframes, jsx } from '@emotion/react';
import { labelStyles, withModifier } from '@zapier/style-encapsulation';
import { Colors } from '../../../theme/Colors.es.js';
import '../../../theme/Shadows.es.js';
import '../../../theme/Typography.es.js';
import 'react';
import { VisuallyHidden } from '../VisuallyHidden/VisuallyHidden.es.js';
import { boxSizing } from '../../../style-mixins/reset.es.js';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;
const sizes = {
  small: {
    diameter: "var(--zds-size-small)",
    thickness: 4
  },
  medium: {
    diameter: "var(--zds-size-medium)",
    thickness: 6
  },
  large: {
    diameter: "var(--zds-size-large)",
    thickness: 10
  }
};
const mapPropToColorValue = (color) => {
  let returnedColor;
  switch (color) {
    case "light":
      returnedColor = Colors.PrimeWhite;
      break;
    case "dark":
      returnedColor = Colors.GrayWarm10;
  }
  return returnedColor;
};
const Styles = labelStyles("Spinner", {
  root: (props) => [
    Object.assign(Object.assign({}, boxSizing), { animation: `${spin} 0.75s linear infinite`, borderStyle: "solid", borderRightColor: "transparent", borderRadius: "50%", opacity: 0.7 }),
    withModifier(props.size, {
      height: sizes[props.size].diameter,
      width: sizes[props.size].diameter,
      borderWidth: `${sizes[props.size].thickness}px`
    }),
    withModifier(props.color, {
      borderColor: mapPropToColorValue(props.color),
      borderRightColor: "transparent"
    })
  ]
});
const Spinner = ({ "aria-label": ariaLabel = "Loading", color = "dark", size = "small" }) => {
  const props = { ariaLabel, color, size };
  return jsx(
    "div",
    { css: Styles.root(props), "data-testid": "spinner", role: "status", "data-zds": true },
    jsx(VisuallyHidden, null, ariaLabel)
  );
};

export { Spinner };
//# sourceMappingURL=Spinner.es.js.map
